import {stringify} from 'devalue'

import {getGeoLocation} from '@/lib/locale/geoLocaltion'
import type {SupportedLocales} from '@/lib/locale/locale'
import call from '@/utils/api/call'
import shouldLogError from '@/utils/api/shouldLogError'
import UnexpectedError from '@/utils/api/UnexpectedError'

export async function getSearchSuggestions({
  locale,
  query,
  signal,
}: {
  locale: SupportedLocales
  query: string
  signal?: AbortSignal
}): Promise<string[]> {
  return call
    .post(
      `/api/model/autocomplete/`,
      {
        data: {
          query,
        },
        localization: {
          locale,
          geo_location: getGeoLocation(),
        },
      },
      {signal},
    )
    .then(res => {
      if (Array.isArray(res.data)) {
        return res.data.map(String)
      }
      throw new Error(`Invalid response from server. Expected array, got ${stringify(res.data)}`)
    })
    .catch(e => {
      if (shouldLogError(e)) {
        console.error(e)
      }
      throw new UnexpectedError(e)
    })
}
